import { useToast } from "../hooks/use-toast";

// Create a simple toast utility for non-React contexts
const showToast = (options) => {
  // You can implement this with a simpler toast library or custom event system
  console.error(`${options.title}: ${options.description}`);
};

export const handleApiError = (error, customMessage = "An error occurred") => {
  console.error('API Error:', error);

  // Get the error message from the response
  const errorMessage = error.response?.data?.message || 
                      error.message || 
                      customMessage;

  // Handle specific status codes
  switch (error.response?.status) {
    case 401:
      // Unauthorized - redirect to login
      window.location.href = '/login';
      return errorMessage;
    
    case 403:
      // Forbidden
      showToast({
        variant: "destructive",
        title: "Access Denied",
        description: errorMessage,
      });
      return errorMessage;

    case 404:
      // Not Found
      showToast({
        variant: "destructive",
        title: "Not Found",
        description: errorMessage,
      });
      return errorMessage;

    case 409:
      // Conflict (e.g., duplicate entry)
      showToast({
        variant: "destructive",
        title: "Conflict",
        description: errorMessage,
      });
      return errorMessage;

    case 422:
      // Validation Error
      const validationErrors = error.response?.data?.errors || [];
      const errorDescription = validationErrors.length > 0
        ? validationErrors.map(err => `${err.field}: ${err.message}`).join('\n')
        : errorMessage;
      
      showToast({
        variant: "destructive",
        title: "Validation Error",
        description: errorDescription,
      });
      return errorDescription;

    default:
      // Generic error
      showToast({
        variant: "destructive",
        title: "Error",
        description: errorMessage,
      });
      return errorMessage;
  }
};

// Create a React hook version for components that need it
export const useApiErrorHandler = () => {
  const { toast } = useToast();
  
  return (error, customMessage = "An error occurred") => {
    console.error('API Error:', error);

    // Get the error message from the response
    const errorMessage = error.response?.data?.message || 
                        error.message || 
                        customMessage;

    // Handle specific status codes
    switch (error.response?.status) {
      case 401:
        // Unauthorized - redirect to login
        window.location.href = '/login';
        return errorMessage;
      
      case 403:
        // Forbidden
        toast({
          variant: "destructive",
          title: "Access Denied",
          description: errorMessage,
        });
        return errorMessage;

      case 404:
        // Not Found
        toast({
          variant: "destructive",
          title: "Not Found",
          description: errorMessage,
        });
        return errorMessage;

      case 409:
        // Conflict (e.g., duplicate entry)
        toast({
          variant: "destructive",
          title: "Conflict",
          description: errorMessage,
        });
        return errorMessage;

      case 422:
        // Validation Error
        const validationErrors = error.response?.data?.errors || [];
        const errorDescription = validationErrors.length > 0
          ? validationErrors.map(err => `${err.field}: ${err.message}`).join('\n')
          : errorMessage;
        
        toast({
          variant: "destructive",
          title: "Validation Error",
          description: errorDescription,
        });
        return errorDescription;

      default:
        // Generic error
        toast({
          variant: "destructive",
          title: "Error",
          description: errorMessage,
        });
        return errorMessage;
    }
  };
};